import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isCalling: false, // True if an outgoing call is initiated
  isReceivingCall: false, // True if an incoming call is ringing
  activeCallDetails: null, // Stores details of the current call (caller, receiver, room_id, type, status)
  ringingModalOpen: false, // Controls visibility of the outgoing ringing modal
  incomingCallModalOpen: false, // Controls visibility of the incoming call modal
  callWindowOpen: false, // Controls visibility of the actual call iframe modal
  callTimer: {
    hours: 0,
    minutes: 0,
    seconds: 0,
    intervalId: null,
  },
};

const slice = createSlice({
  name: "call",
  initialState,
  reducers: {
    startOutgoingCall(state, action) {
      state.isCalling = true;
      state.isReceivingCall = false;
      state.activeCallDetails = { ...action.payload, status: 'ringing' };
      state.ringingModalOpen = true;
      state.incomingCallModalOpen = false;
      state.callWindowOpen = false;
      state.callTimer = initialState.callTimer; // Reset timer
    },
    receiveIncomingCall(state, action) {
      state.isCalling = false;
      state.isReceivingCall = true;
      state.activeCallDetails = { ...action.payload, status: 'incoming' };
      state.ringingModalOpen = false;
      state.incomingCallModalOpen = true;
      state.callWindowOpen = false;
      state.callTimer = initialState.callTimer; // Reset timer
    },
    acceptCall(state, action) {
      state.isCalling = false;
      state.isReceivingCall = false;
      state.activeCallDetails = { ...action.payload, status: 'accepted' };
      state.ringingModalOpen = false;
      state.incomingCallModalOpen = false;
      state.callWindowOpen = true;
      state.callTimer = initialState.callTimer; // Reset timer
    },
    endCall(state) {
      state.isCalling = false;
      state.isReceivingCall = false;
      state.activeCallDetails = null;
      state.ringingModalOpen = false;
      state.incomingCallModalOpen = false;
      state.callWindowOpen = false;
      state.callTimer = initialState.callTimer; // Reset timer
    },
    denyCall(state) {
      state.isCalling = false;
      state.isReceivingCall = false;
      state.activeCallDetails = null;
      state.ringingModalOpen = false;
      state.incomingCallModalOpen = false;
      state.callWindowOpen = false;
      state.callTimer = initialState.callTimer; // Reset timer
    },
    resetCallTimer(state) {
      state.callTimer.hours = 0;
      state.callTimer.minutes = 0;
      state.callTimer.seconds = 0;
    },
    incrementCallTimer(state) {
      state.callTimer.seconds++;
      if (state.callTimer.seconds >= 60) {
        state.callTimer.minutes++;
        state.callTimer.seconds = 0;
      }
      if (state.callTimer.minutes >= 60) {
        state.callTimer.hours++;
        state.callTimer.minutes = 0;
      }
    },
    resetCallState(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  startOutgoingCall,
  receiveIncomingCall,
  acceptCall,
  endCall,
  denyCall,
  resetCallTimer,
  incrementCallTimer,
  resetCallState,
} = slice.actions;

export default slice.reducer;

// Thunk functions
export function StartOutgoingCall(callDetails) {
  return async (dispatch) => {
    dispatch(slice.actions.startOutgoingCall(callDetails));
  };
}

export function ReceiveIncomingCall(callDetails) {
  return async (dispatch) => {
    dispatch(slice.actions.receiveIncomingCall(callDetails));
  };
}

export function AcceptCall(callDetails) {
  return async (dispatch) => {
    dispatch(slice.actions.acceptCall(callDetails));
  };
}

export function EndCall() {
  return async (dispatch) => {
    dispatch(slice.actions.endCall());
  };
}

export function DenyCall() {
  return async (dispatch) => {
    dispatch(slice.actions.denyCall());
  };
}

export function ResetCallState() {
  return async (dispatch) => {
    dispatch(slice.actions.resetCallState());
  };
}